export default {
  name: 'App'
};